import config from 'Config';

export const SLIDER_CLASSNAME = 'Pos(r) Pb(0) Pt(0) W(98%) My(0)';
export const CTA_BUTTON_CLASSNAME =
  'Bdc($c-ds-divider-primary) Ov(h) CenterAlign Fxg(1) Px(24px) Py(20px) Ta(inh) Typs(button-1)';
export const PASSIONS_CLASSNAME =
  'Bdc($c-ds-border-button-secondary) Bdw(2px) C($c-ds-foreground-button-secondary)';
export const discoverySettings = config.discoverySettings || {};

export const APP_SOURCE_LIKES_LIST = 'likeslist';

export const FILTER_TRAY_FILTER_ID = 'filterTray';
export const DISTANCE_FILTER_ID = 'distance';
export const AGE_RANGE_FILTER_ID = 'ageRange';
export const MIN_PHOTOS_FILTER_ID = 'minPhotos';
export const PASSIONS_FILTER_ID = 'passions';
export const PHOTO_VERIFIED_FILTER_ID = 'photoVerified';
export const HAS_BIO_FILTER_ID = 'hasBio';

export const MAX_FILTER_AGE = discoverySettings.ageMax;
export const MIN_FILTER_AGE = discoverySettings.ageMin;

export const MIN_PHOTO_MIN_NUM = discoverySettings.numPhotosMin;
export const MIN_PHOTO_MAX_NUM = discoverySettings.numPhotosMax;

export const MAX_FILTER_DISTANCE = discoverySettings.distanceMax;
export const MAX_FILTER_DISTANCE_KM = discoverySettings.distanceMaxKm;
export const MIN_FILTER_DISTANCE = discoverySettings.distanceMin;

export const MAX_SELECTED_PASSIONS_COUNT = 150; // arbitrary large number
